<template>
  <span>
    <span v-if="string < 0" class="generic-bubble danger-bubble"></span>
    <span v-if="string > 0" class="generic-bubble success-bubble"></span>
    {{ formatCurrency(absAmount) }}
    </span>
</template>

<script setup>
import {formatCurrency} from "@/extensions/filters/filters"
import {computed} from "vue"

const props = defineProps({
  string: {
    type: [String, Number],
    required: true
  }
})

const absAmount = computed(() => Math.abs(Number(props.string)))
</script>

<style scoped lang="scss">
.generic-bubble {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  display: inline-block;
  &.danger-bubble {
    background-color: $danger-red;
  }
  &.success-bubble {
    background-color: $green-color;
  }
}
</style>
